module.exports = __webpack_public_path__ + "img/amulex.5cd24054.png";